module.exports = __webpack_public_path__ + "img/login1.c2cb42c2.png";